import data from "../../../../../src/deprecated/FilterList/FilterList.docs.json";
import * as React from 'react';
export default {
  data,
  React
};